import Vue from 'vue';
import Router from 'vue-router';

import { routes } from '@/config';

import Login from '@/pages/Login';
import MiniLogin from '@/pages/MiniLogin';
import Register from '@/pages/Register';
import CertificationRedirect from '@/pages/Certification/redirect';

import UpdateCertification from '@/pages/Certification/company/update';
import ViewCertification from '@/pages/Certification/company/view';
import CreateCertification from '@/pages/Certification/company/create';
import CertificationExtend from '@/pages/Certification/company/extend';

import EditPersonalCerfification from '@/pages/Certification/personal/edit';
import ViewPersonalCerfification from '@/pages/Certification/personal/view';

import ChooseService from '@/pages/ChooseService';
import ChoosePersonalServices from '@/pages/ChooseService/personal';
import ChooseCompanyServices from '@/pages/ChooseService/company';

import PlatformIndex from '@/pages/PlatformIndex';
import ResetPassword from '@/pages/ResetPassword';

Vue.use(Router);

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  },
  routes: [
    {
      path: routes.index,
      name: 'Index',
      component: Login
    },
    {
      path: routes.login,
      name: 'Login',
      component: Login
    },
    {
      path: routes.miniLogin,
      name: 'MiniLogin',
      component: MiniLogin
    },
    {
      path: routes.register,
      name: 'Register',
      component: Register
    },
    {
      path: routes.viewCertification,
      name: 'view-certification',
      component: ViewCertification,
      exact: true,
    },
    {
      path: routes.createCertification,
      name: 'create-certification',
      component: CreateCertification,
    },
    {
      path: routes.certificationExtend,
      name: 'extend-certification',
      component: CertificationExtend,
    },
    // 临时用，兼容以前的url
    {
      name: 'certification-redirect',
      path: routes.certificationRedirect,
      component: CertificationRedirect,
    },
    {
      path: routes.certificationSupplement,
      name: 'certification-supplement',
      component: CertificationRedirect,
    },
    {
      path: routes.certification,
      name: 'Certification-update',
      component: UpdateCertification,
    },
    // 个人账户
    {
      path: routes.editPersonalCertification,
      component: EditPersonalCerfification,
      name: 'create-personal-certification',
    },
    {
      path: routes.viewPersonalCertification,
      component: ViewPersonalCerfification,
      name: 'view-personal-certification',
    },
    {
      path: routes.chooseService,
      name: 'ChooseService',
      component: ChooseService,
      redirect: {
        name: routes.chooseCompany.name,
      },
      children: [
        {
          path: routes.chooseCompany.path,
          name: routes.chooseCompany.name,
          component: ChooseCompanyServices,
        },
        {
          path: routes.choosePersonal.path,
          name: routes.choosePersonal.name,
          component: ChoosePersonalServices,
        },
      ],
    },
    {
      path: routes.platformIndex,
      name: 'PlatformIndex',
      component: PlatformIndex
    },
    {
      path: routes.resetPassword,
      name: 'ResetPassword',
      component: ResetPassword
    }
  ]
});
